export enum PaymentPlatformIdentifier {
  PAYPAL = "PAYPAL",
  STRIPE = "STRIPE",
  SATISPAY = "SATISPAY",
  CREDIT_CARD = "CREDIT CARD",
}

interface PaymentPlatform {
  activity_id: number;
}

interface PaypalConfig extends PaymentPlatform {
  client_id: string;
  client_secret: string;
  is_sandbox: boolean;
}

interface StripeConfig extends PaymentPlatform {
  secret_key: string;
}

interface SatispayConfig extends PaymentPlatform {
  key_id: string;
  private_key: string;
  sandbox: boolean;
}
